export default __webpack_public_path__ + "static/Inter-subset-d1b28f464afe95e089c980bb9842a238.woff2";